<template>
    <div class="view-tasklists">
        <user-menu />
        <div class="wrapper">
            <masteradmin-sidebar-menu />
            <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div>
                        <h3 class="d-inline heading">Courses</h3>
                       
                    </div>
                    <div class="heading-seperator"></div>
                    <div class="margin-bottom-10"></div>
                    <!--
                    <div class="">
                        <b-navbar toggleable="lg" type="light" variant="light">
                            <b-navbar-brand href="#">Filter/Search</b-navbar-brand>
                            <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>
                            <b-collapse id="nav-collapse" is-nav>
                                <div class="search-wrapper col-12">
                                    <div class="row col-12 override-padding">
                                        <div class="col-lg-4 col-md-6 col-6">
                                            <b-form-input
                                            class="input-text"
                                            v-model="search_name"
                                            type="text"
                                            placeholder="Unit Type"
                                            ></b-form-input>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-6">
                                            <b-form-select class="input-text" v-model="search_validity_duration" :options="validityDurationOptions"></b-form-select>
                                        </div>
                                        <div class="col-lg-3 col-md-10 col-10">
                                            <b-form-select class="input-text" v-model="search_is_active" :options="packageStatusOptions"></b-form-select>
                                        </div>
                                        <div class="col-lg-1 col-md-2 col-2 search-icon-wrapper cursor-pointer" @click="filterPackagelistitems()">
                                            <span class="search-icon">
                                            <i class="fa fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </b-navbar>
                    </div>
                    -->
                    <div class="margin-bottom-10"></div>
                    <div>
                        <b-card no-body>
                            <div class="row tasks_heading_row">
                                <div class="bold cursor-pointer  col-3">
                                    Course Title                                    
                                </div>
                                <div class="bold cursor-pointer  col-1 override-padding">
                                    Course ID
                                </div>
                                <div class="bold cursor-pointer col-1 override-padding">
                                    # of Modules
                                </div>
                                <div class="bold cursor-pointer col-2 override-padding">
                                     # of Final Exam Q's
                                </div>
                                <div class="bold cursor-pointer col-1 override-padding">
                                    Last Updated
                                </div>
                                <div class="bold cursor-pointer col-2 override-padding">
                                    Last Updated by 
                                </div>
                                <div class="bold cursor-pointer col-1 override-padding">
                                    # of Affiliates
                                </div>
                                <div class="bold cursor-pointer col-1 override-padding">
                                    Access
                                </div>
                            </div>
                            <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                            <b-card-text v-if="course_lists.length > 0">
                                <div v-for="(courseinfo, index) in course_lists" class="tasklist-row">
                                    <div class="row tasklist-item"  style="margin: 0;">
                                        <div class="col-3 package-name">{{courseinfo.course_name}}</div>
                                         <div class="col-1 override-padding">{{courseinfo.course_id}}</div>
                                        <div class="col-1 override-padding">{{courseinfo.module_count}}</div>
                                        <div class="col-2 override-padding">{{courseinfo.questions_count}}</div>
                                        <div class="col-1 override-padding">{{courseinfo.updated_time}}</div>
                                        <div class="col-2 override-padding">{{courseinfo.updated_by}}</div>                       
                                        <div class="col-1 override-padding">{{courseinfo.no_of_affiliates}}</div>
                                        <div class="col-1 override-padding">
                                           <a  @click="manageCourse(courseinfo.course_id, courseinfo.course_name)" id="manage-link">Manage</a>
                                        </div>
                                    </div>
                                    <div><hr></div>
                                </div>
                                
                            </b-card-text>
                            <b-card-text v-else-if="loading == false">
                                    No Courses found.
                            </b-card-text>
                        </b-card>
                    </div>
                </div>
                
    <ManageCourseModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>

      <div slot="header">
       <div class="sub-heading"><h3 style="font-size: 14px;">Course: {{courseTitle}}</h3></div>
      </div> 
      
      <div slot="body">

        

        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="affiliate_selected"
            :options="affiliate_options" track-by="name" label="name"
            placeholder="Select Affiliates..." :multiple="true"  :close-on-select="false" :show-labels="false"
            v-validate="'required'"
            name="affiliate"
            id="affiliate"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">Affiliates ({{ values.length }} selected)</span></template>
          </multiselect>
          <div v-if="verrors.firstByRule('affiliate', 'required')" class="margin-bottom-5 validate-warning-msg">Affilates is required</div>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
  
        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="roles_selected"
            :options="roles_options"
            track-by="name" label="name"
            placeholder="Select Users..."
            :multiple="true" 
            :close-on-select="false"
            :show-labels="false"
            v-validate="'required'"
            name="roles"
            id="roles"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">Users ({{ values.length }} selected)</span></template>
      

          </multiselect>
          <div v-if="verrors.firstByRule('roles', 'required')" class="margin-bottom-5 validate-warning-msg">Users is required</div>

          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>


        <div class="col-12 override-padding text-align-right">
          <button
              v-on:click="saveCourseAffiliates()"
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>Save</b></button>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ManageCourseModal>

            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import ManageCourseModal from './manage_course_modal.vue';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import Multiselect from 'vue-multiselect';


export default {
    data() {
        return {            
            loading: false,            
            isModalVisible: false,
            course_lists: [],          
            affiliate_options: [],
            roles_options: [
              {
                name: 'Admin',
                value: 'ROLE_ADMIN',
              },
              {
                name: 'Mentor',
                value: 'ROLE_MENTOR',
              },
              {
                name: 'Mentee',
                value: 'ROLE_MENTEE',
              },
              {
                name: 'Apprentice',
                value: 'ROLE_APPRENTICE',
              },
              {
                name: 'Instructor',
                value: 'ROLE_INSTRUCTOR',
              },
              {
                name: 'Student',
                value: 'ROLE_STUDENT',
              },
            ],
            affiliate_selected: [],
            roles_selected: [],
            course_selected: '',
            courseTitle: '',
        }
    },
    components: {
        UserMenu,
        ManageCourseModal,
        MasteradminSidebarMenu,
        Multiselect,
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },       
        toggleDropdown (id) {
            document.getElementById(id).classList.toggle("show");
        },
        fetchCourseListitems() {
            this.loading = true;
            const params = { };
            axios.get('/manage-course', {
                params: params
            })
            .then((resp) => {
                this.loading = false;
                this.course_lists = resp.data;
                this.currentPage = 1;
                this.rows = 10;
            })
            .catch(error => {

            });
        },
        fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, name: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

        },
        manageCourse(courseId, courseName) {
            this.course_selected = courseId;
            this.courseTitle = courseName;
            axios.get('/course-affiliate-roles/' + this.course_selected)
              .then((resp) => {                  
                  this.roles_selected = resp.data.roles_assigned;
                  this.affiliate_selected = resp.data.affiliate_assigned;
               })
              .catch(error => {

              });
  
            this.isModalVisible = true; 
            verrors.clear();
        },
        saveCourseAffiliates: function() {            
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                  axios('/course/assign-affiliate',
                     {
                       method: 'POST',
                       data:
                        {
                          course_id: this.course_selected,
                          affiliate_selected: this.affiliate_selected,
                          roles_selected: this.roles_selected,
                        },
                     }
                   )
                  .then((resp) => {                      
                      this.affiliate_selected = [];
                      this.roles_selected = [];
                      this.isModalVisible = false;
                      this.$emit('close');                      
                      //router.push("/assessment-add-section/" + resp.data);
                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });

              }
            });
        },
    },
    created() {
        this.fetchCourseListitems();
        this.fetchAffiliateOptions();
        document.body.className = 'naicslist-page';
    },
}
</script>
<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 25px;
  color: #FFF;
  padding: 3px 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.input-height-30 {
  line-height: 30px;
}
.naics-code-wrapper {
  padding-left: 15px;
}
hr {
  border-top: 2px solid #8b8b8b;
  margin: 0px;
}
.tasklist-row:nth-of-type(odd) {
  background-color:#fff;
}
.tasklist-row:nth-of-type(even) {
  background-color:#e9e9e9;
}
.search-wrapper {
  background-color: transparent;
}
.heading-seperator {
  border-bottom: 2px solid #00ACEE;
}
.btn-blue {
  background-color: #dc2227 !important;
  border: 1px solid #dc2227 !important;
}
.create-btn {
    line-height: 15px;
    font-weight: bold;
    font-size: 13px;
}
.heading {
  font-size: 15px;
}
.tasklist-item {
  padding: 8px 0px 8px 0px;
}
.package-name {
  padding-left: 20px;
}
#manage-link {
  color: #00ACEE;
  text-decoration: underline; 
}
</style>
<style>
.input-height-30 {
  line-height: 28px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: #fff !important;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/course_list.vue